import React from 'react';
import type { ComponentProps } from 'react';
import { useFormikContext } from 'formik';

import Button from 'components-new/button/button';

const SubmitButton = (props: ComponentProps<typeof Button>): JSX.Element => {
  const { dirty, isValid } = useFormikContext();
  return <Button {...props} disabled={!(dirty && isValid)} />;
};

export default SubmitButton;
